import React from 'react';
import '../../layout/Page404.css';

const Unauthorized = () => {
    return (
        <div className="page-404-container">
            <h3 className="page-404-title">Unauthorized</h3>
            <p className="page-404-message">Oops! You don't have permission to access this page.</p>
            <button onClick={() => window.location = '#/Settings'} className="page-404-link">Go Back</button>
        </div>
    );
};

export default Unauthorized;
